import React from 'react';
import { FormControl, FormHelperText, InputAdornment, OutlinedInput, Stack } from '@mui/material';

import { isValidAmount } from '../helpers';
import { FlagsDropdown } from './FlagsDropdown';
import { StyledInput } from './StyledComponents/GoalAmountInputStyles';

export function GoalAmountInput({ selectedCurrencyOption, currencyChangeHandler, amountProps, disableCurrencyEdit = false, className }) {
	const validateDonationAmount = (event) => {
		if (!isValidAmount(event.key)) {
			event.preventDefault();
		}
	};
	return (
		<StyledInput sx={{ width: '100%' }}>
			<Stack direction={{ xs: 'column', sm: 'row' }} alignItems="center">
				<FlagsDropdown
					className={className}
					selectedOption={selectedCurrencyOption}
					onChange={currencyChangeHandler}
					disableEdit={disableCurrencyEdit}
				/>

				<FormControl variant="outlined" fullWidth>
					<OutlinedInput
						{...amountProps}
						onKeyPress={validateDonationAmount}
						size="small"
						onWheel={(e) => e.target.blur()}
						endAdornment={
							<InputAdornment position="end" sx={{ marginLeft: '5px', '& p': { marginTop: '0 !important', fontWeight: '600 !important', color: '#333333 !important' } }}>
								.00
							</InputAdornment>
						}
					/>
				</FormControl>
			</Stack>

			<FormHelperText error>{amountProps.helpertext}</FormHelperText>
		</StyledInput>
	);
}
